import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import agent from '../agent';


export const recontractSubmitLog = createAsyncThunk(
  "recontract/recontractSubmitLog",
  async (payload, thunkApi) => {
    try {
      const response = await agent.requests.post("/recontract", payload);
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

const initialState = {
  status: "idle",
  loading: false,
  error: null,
  recontractLogResponse: null,
};

const recontractSlice = createSlice({
  name: 'recontract',
  initialState,
  reducers: {
    resetStatus: (state) => {
      state.status = "idle";
      state.error = null;
      state.recontractLogResponse = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(recontractSubmitLog.pending, (state) => {
        state.status = "recontractSubmitLog/loading";
      })
      .addCase(recontractSubmitLog.fulfilled, (state, action) => {
        state.status = "recontractSubmitLog/success";
        state.recontractLogResponse = action.payload;
      })
      .addCase(recontractSubmitLog.rejected, (state, action) => {
        state.status = "recontractSubmitLog/failed";
        state.error = action.payload;
      });
  },
});


export const { resetStatus } = recontractSlice.actions;


export const selectRecontractStatus = (state) => state.recontract?.status;
export const selectRecontractLogResponse = (state) => state.recontract?.recontractLogResponse;
export const selectRecontractError = (state) => state.recontract?.error;


export default recontractSlice.reducer;
